export enum LogoParamEnum {
  logoPrincipal = 1,
  logoHome = 2
}
